export enum PaymentType {
  CashInstallments = 'cash_installments',
  InstoreConsumer = 'instore_consumer',
  Kueskipay = 'kueskipay',
}

export enum PaymentChannel {
  Ecommerce = 'ecommerce',
  Instore = 'instore',
  Online = 'online',
  Enterprise = 'enterprise',
}

export interface PaymentCallbacks {
  onFailed: string;
  onReject: string;
  onSuccess: string;
  onCanceled: string;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PaymentExchangerate {
}

export interface PaymentItem {
  sku: string;
  tax: number;
  name: string;
  price: number;
  quantity: number;
  description: string;
}

export type Payment = {
  tax: number;
  term?: number;
  items: PaymentItem[];
  amount: number;
  status: string;
  channel: string;
  firstInstallment?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loanId?: any;
  currency: string;
  discount: number;
  orderId: string;
  shipping: number;
  subtotal: number;
  callbacks: PaymentCallbacks;
  channelId: number;
  createdAt: string;
  paymentId: string;
  paymentIntentId: string;
  description: string;
  merchantId: string;
  handlingFee: number;
  merchantUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  voucherCode?: any;
  merchantLogo: string;
  merchantName: string;
  realMerchantName?: string;
  refundedAmount: number;
  integrationName: string;
  merchantCategory: string;
  merchantIndustry: string;
  merchantOfferId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  merchantPromotion?: any;
  merchantCategoryCode: string;
  availableMoneyToRefund: number;
  originalAmount: number;
  discountAmount: number;
  exchangeRate: PaymentExchangerate;
  paymentType: PaymentType;
  storeId?: string;
}

export interface Auth {
  bearer: string;
  domain: string;
}

export interface MerchantPaymentResponse {
  payment: Payment | null;
  status: string;
  auth: Auth;
}
